import { useNavigate } from 'react-router-dom';
/** Components */
import Table from 'components/Table';
/** Services */
import { removeSupplierBillInvoices } from 'services/invoices';
/** Utils */
import { createToast } from 'utils/toast';
/** Constants */
import { BILL_INVOICES_HEAD_CELLS } from 'constants/providers';
/** Styles */
import styles from './BillInvoiceList.module.scss';

const BillInvoiceList = ({
  invoices = [],
  providers = [],
  onDeleteInvoices,
}) => {
  const navigate = useNavigate();

  const mappedBillInvoices = invoices.map(
    ({
      invoiceNumber = '',
      date,
      supplierId,
      basePrice,
      totalPrice,
      vat,
      id,
    }) => {
      return {
        ...(invoiceNumber
          ? { invoiceNumber }
          : { invoiceNumber: 'Sin nº de factura' }),
        ...(date ? { date } : { date: 'Sin fecha' }),
        ...(supplierId
          ? { supplierId: providers.find(({ id }) => id === supplierId).name }
          : { supplierId: 'Sin proveedor' }),
        ...(basePrice ? { basePrice } : { basePrice: '-' }),
        ...(totalPrice ? { totalPrice } : { totalPrice: '-' }),
        // ...(vat ? { vat } : { vat: '-' }),
        // metadata: { fileId: id, key: 'supplierBillInvoice' },
        ...(id && { id }),
      };
    }
  );

  const handleSelectInvoice = (invoiceId) => {
    navigate(`/proveedores/abonos/${invoiceId}`);
  };

  const deleteHandler = (invoicesIds) => {
    removeSupplierBillInvoices(invoicesIds)
      .then(({ status }) => {
        if (status === 204) {
          createToast({
            text: 'Factura de abonos del proveedor eliminada con éxito',
            type: 'success',
            duration: 2500,
          });
          onDeleteInvoices(invoicesIds);
        }
      })
      .catch(() => {
        createToast({
          text: 'No se ha podido eliminar la factura de abonos del proveedor, inténtalo de nuevo más tarde',
          type: 'error',
        });
      });
  };

  return (
    <>
      {invoices.length !== 0 ? (
        <Table
          rowsData={mappedBillInvoices}
          headCells={BILL_INVOICES_HEAD_CELLS}
          ignoreColumn="id"
          targetItem="id"
          orderBy="id"
          setItem={handleSelectInvoice}
          deleteHandler={(value) => deleteHandler(value)}
        />
      ) : (
        <div className={styles.EmptyState}>No hay datos.</div>
      )}
    </>
  );
};

export default BillInvoiceList;
